import { Dropdown as DropdownAntd, DropdownProps } from 'antd';

import styled from '@/styled';

const Dropdown = ({ children, className, ...rest }: DropdownProps) => (
  <DropdownAntd overlayClassName={className} {...rest}>
    {children}
  </DropdownAntd>
);

export default styled(Dropdown)`
  .ant-dropdown-menu {
    border: 1px solid ${({ theme }) => theme.variables.borderColor};
    padding: 0;
  }

  .ant-dropdown-menu .ant-dropdown-menu-item {
    border-bottom: 1px solid ${({ theme }) => theme.variables.borderColor};
    padding: ${({ theme }) => theme.space.spacing(4, 5)};
    border-radius: 0;
  }
`;
